export const maintenanceConfig = {
  // Set this to true to enable maintenance mode for the public
  isMaintenanceMode: false,
  
  // The secret key to bypass maintenance mode (e.g., visit ?admin=true)
  bypassKey: "admin"
};